module.exports = __webpack_public_path__ + "media/images/logo-small-41182729.png";